<template>
  <iColumn
    gap="none"
    overflow="auto"
    wrap="nowrap"
  >
    <template
      v-for="semanticContext in mySemanticPaletteList"
      :key="semanticContext.key"
    >
      <iRow
        wrap="nowrap"
        vertical-align="middle"
        align="between"
        :style-overrides="{
          paddingLeft: 'standard',
          paddingRight: 'standard',
        }"
        :class="{
          'color-row':true,
          selected: isSelected(semanticContext)
        }"
      >
        <iRow width="fill" vertical-align="middle">
          <iText class="title">
            {{ camelToTitleCase(semanticContext.key) }}
          </iText>
        </iRow>
        <iRow
          vertical-align="middle"
          gap="none"
          wrap="nowrap"
          align="center"
          width="fill"
        >
          <template v-for="color in semanticContext.values" :key="color.key">
            <ColorSwatch
              :color="color.value"
              :width="24"
              :is-active="modelValue === `${semanticContext.key}.${color.key}`"
              :title="color.key"
              :active-group="isSelected(semanticContext)"
              as-button
              @click.stop="selectValue(semanticContext, color)"
            />
          </template>
        </iRow>
      </iRow>
    </template>
  </iColumn>
</template>

<script>
import ColorSwatch from "%/components/color-picker/ColorSwatch.vue";
import { mapState } from "pinia";
import { useStyleStore } from "@bloglovin/vue-component-library";
import { CONTRAST_LIGHT_MODE, CONTRAST_DARK_MODE } from "~/constants/color-palette-editor-constants";
import { camelToTitleCase } from "@bloglovin/vue-framework";

export default {
  name: "SemanticColorPicker",
  components: {
    ColorSwatch,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
    context: {
      type: String,
      required: false,
      default: "font",
    },
    contextThemeId: {
      type: Number,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      CONTRAST_LIGHT_MODE, CONTRAST_DARK_MODE,
    };
  },
  computed: {
    ...mapState(useStyleStore, ["mySemanticPaletteFromMode", "semanticPalettes"]),
    mySemanticPaletteList() {
      const semanticPalette = this.semanticPalettes[this.contextThemeId];
      const lightModePalette = semanticPalette[CONTRAST_LIGHT_MODE];
      const darkModePalette = semanticPalette[CONTRAST_DARK_MODE];

      return Object.keys(darkModePalette).map(paletteKey => ({
        key: paletteKey, values: Object.keys(darkModePalette[paletteKey]).map(rowKey => ({
          key: rowKey,
          value: {
            [CONTRAST_LIGHT_MODE]: lightModePalette[paletteKey][rowKey],
            [CONTRAST_DARK_MODE]: darkModePalette[paletteKey][rowKey],
          },
        })),
      }));
    },
  },
  methods: {
    camelToTitleCase,
    isSelected(value) {
      for (const colorKey in value.values) {
        const color = value.values[colorKey];
        if (this.modelValue === `${value.key}.${color.key}`) {
          return true;
        }
      }
      return false;
    },
    selectValue(semanticContext, color) {
      this.$emit("update:modelValue", `${semanticContext.key}.${color.key}`);
    },
  },
  styleGuide: () => ({
    hoverBackgroundColor: { "color.background": "light" },
    selectedBackgroundColor: { "color.border": "striking" },
  }),
};
</script>

<style lang="scss" scoped>
.color-row {
  &.row {
    padding-block: 3px;
  }

  &.row:hover {
    cursor: pointer;
    background-color: v-bind("$getStyles.hoverBackgroundColor");
  }

  &.row.selected {
    background-color: v-bind("$getStyles.selectedBackgroundColor");
  }
}
</style>
